var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { InlineChildren, Stack, StackChildren, Text, } from '@doordash/design-language';
import { TextField } from '@doordash/component-fields';
import styled from 'styled-components';
import * as yup from 'yup';
import { QuickStartPageData } from '../../EmOnboardingPageData';
import { formatMoney, getDefaultCurrencySymbol, } from '@doordash/lib-i18n';
var strings = QuickStartPageData.budgetForm;
var InputFieldContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 48%;\n"], ["\n  width: 48%;\n"])));
export var initialBudgetFormValues = {
    budgetName: '',
    budgetAmount: null,
};
export var budgetFormValidationSchema = function (maxBudgetLimitInCents) { return ({
    budgetName: yup.string().required(strings.errors.budgetNameIsRequired),
    budgetAmount: maxBudgetLimitInCents
        ? yup
            .number()
            .positive()
            .max(maxBudgetLimitInCents / 100, function (_a) {
            var max = _a.max;
            return strings.errors.budgetAmountLimit(max.toString());
        })
            .typeError(strings.errors.budgetAmountShouldBeNumber)
            .required(strings.errors.budgetAmountIsRequired)
        : yup
            .number()
            .positive()
            .typeError(strings.errors.budgetAmountShouldBeNumber)
            .required(strings.errors.budgetAmountIsRequired),
}); };
export var BudgetForm = function (_a) {
    var currenyCode = _a.currenyCode, userLocale = _a.userLocale, maxBudgetAmountLimit = _a.maxBudgetAmountLimit, errors = _a.errors, values = _a.values, handleChange = _a.handleChange;
    var getBudgetAmountFieldLabel = function (currency, locale, maxBudgetAmount) {
        if (maxBudgetAmount) {
            var localizedAmountString = formatMoney({
                currency: currency,
                userLocale: locale,
                unitAmount: maxBudgetAmount,
            });
            return strings.budgetAmount.labelUpTo(localizedAmountString);
        }
        return strings.budgetAmount.labelDefault(getDefaultCurrencySymbol(currency));
    };
    return (React.createElement(StackChildren, { size: Stack.Sizes.Small },
        React.createElement(Text, { styles: Text.Styles.Body1, color: Text.Colors.TextSecondary },
            "Create a",
            ' ',
            React.createElement(Text, { styles: Text.Styles.Body1Emphasis, color: Text.Colors.TextSecondary, display: Text.DisplayModes.Inline, children: "one-time budget" }),
            ' ',
            "that will",
            ' ',
            React.createElement(Text, { styles: Text.Styles.Body1Emphasis, color: Text.Colors.TextSecondary, display: Text.DisplayModes.Inline, children: "expire in 24 hours" }),
            ". You will be able to use it on your next DoorDash order. You will only get charged when you place an order using this meal budget."),
        React.createElement(InlineChildren, { size: InlineChildren.Sizes.XSmall, justifyContent: InlineChildren.Justification.SpaceBetween },
            React.createElement(InputFieldContainer, null,
                React.createElement(TextField, { isDisabled: false, autoComplete: "off", label: strings.budgetName.label, error: errors.budgetName, placeholder: strings.budgetName.placeholder, onChange: handleChange(strings.budgetName.id), isRequired: true, value: values.budgetName, "data-anchor-id": strings.budgetName.id, maxLength: 255 })),
            React.createElement(InputFieldContainer, null,
                React.createElement(TextField, { isDisabled: false, autoComplete: "off", label: getBudgetAmountFieldLabel(currenyCode, userLocale, maxBudgetAmountLimit), error: errors.budgetAmount, placeholder: strings.budgetAmount.placeholder, onChange: handleChange(strings.budgetAmount.id), isRequired: true, value: values.budgetAmount ? values.budgetAmount : '', "data-anchor-id": strings.budgetAmount.id, maxLength: 255 })))));
};
var templateObject_1;
